import { useEffect, useMemo } from "react";
import { SmartViewKind } from "@/domains/smart/constants";
import { resolveSmartContextId } from "@/store/heads-up/SmartContextId";
import type { AppStore } from "@/store/AppStore";

export interface HeadsUpContextInfo {
  contextId: string | null;
  activeNoteId: string | null;
  spaceAccountId: string | null;
  isDatabaseReady: boolean;
}

export function useContextId(store: AppStore): HeadsUpContextInfo {
  const activeNoteId = store.routing.noteIdParam ?? null;
  const spaceAccountId = store.spaceAccounts.myPersonalSpaceAccountId ?? null;
  const isDatabaseReady = store.database.isInitialized();

  const contextId = useMemo(() => {
    return resolveSmartContextId({
      spaceAccountId,
      activeNoteId,
      smartViewKind: SmartViewKind.HeadsUp,
    });
  }, [spaceAccountId, activeNoteId]);

  useEffect(() => {
    store.headsUp.setActiveContextId(contextId);
    return () => store.headsUp.setActiveContextId(null);
  }, [contextId, store.headsUp]);

  return {
    contextId,
    activeNoteId,
    spaceAccountId,
    isDatabaseReady,
  };
}
